/*
 * @@Author: MuYang
 */
import {assign} from 'lodash-es'
import store from '../store'

function install ({customHandle, componentsProps}) {
  if (customHandle) {
    const _handle = assign(store.handle, customHandle)
    store.handle = _handle
  }
  if (componentsProps) {
    store.componentsProps = componentsProps
  }
}

export default install
